import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const names = ['Sofía M.', 'Carolina R.', 'Valentina F.', 'Luciana G.', 'Camila P.', 'Florencia D.', 'María José L.', 'Agustina S.', 'Julieta B.', 'Rocío T.', 'Paula V.', 'Daniela H.', 'Micaela N.', 'Antonella C.', 'Martina R.', 'Guadalupe A.', 'Constanza M.', 'Belén F.', 'Pilar S.', 'Milagros K.', 'Andrea L.', 'Natalia Q.', 'Silvina E.', 'Lorena J.', 'Mariana W.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'San Miguel de Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Corrientes', 'Posadas', 'San Luis', 'Bahía Blanca', 'Paraná', 'Formosa', 'San Rafael', 'Tandil', 'Río Cuarto', 'Concordia', 'San Nicolás', 'Rafaela', 'Pergamino'];
const offers = ['PILATES 360', 'PILATES 360 + Safe Pilates Pro™'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval(): number {
  return (Math.random() * 40 + 40) * 1000; // 40-80 seconds
}
function getTimeAgo(): string {
  const minutes = Math.floor(Math.random() * 12) + 1;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    offer: '',
    timeAgo: ''
  });
  const showNotification = useCallback(() => {
    setNotification({
      name: getRandomItem(names),
      city: getRandomItem(cities),
      offer: getRandomItem(offers),
      timeAgo: getTimeAgo()
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // First popup after 40-80s
    let timeout = setTimeout(() => {
      showNotification();
      // Then repeat
      const startInterval = () => {
        timeout = setTimeout(() => {
          showNotification();
          startInterval();
        }, getRandomInterval());
      };
      startInterval();
    }, getRandomInterval());
    return () => clearTimeout(timeout);
  }, [showNotification]);
  return <AnimatePresence data-id="element-330">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-331">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-3.5 flex items-start gap-3 relative" data-id="element-332">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Cerrar" data-id="element-333">
              <XIcon className="w-3.5 h-3.5" data-id="element-334" />
            </button>

            <div className="w-9 h-9 bg-sage-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-335">
              <ShoppingBagIcon className="w-4 h-4 text-sage-700" data-id="element-336" />
            </div>

            <div className="pr-4" data-id="element-337">
              <p className="text-sm text-charcoal leading-snug" data-id="element-338">
                <span className="font-bold" data-id="element-339">{notification.name}</span> de{' '}
                <span className="font-semibold text-sage-700" data-id="element-340">
                  {notification.city}
                </span>{' '}
                adquirió <span className="font-bold" data-id="element-341">{notification.offer}</span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1 flex items-center gap-1" data-id="element-342">
                <span className="inline-block w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" data-id="element-343"></span>
                {notification.timeAgo}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}